import { lenis, scrollState } from "@animations/lenis";
import { ScrollTrigger } from "@animations/lenis";
import { initReveals } from "@animations/reveals";
import { initSplitText } from "@animations/splitText";
import { AboutScene } from "@scenes/AboutScene";
import { HeroScene } from "@scenes/HeroScene";
import { World } from "@world/World";

import "./styles/main.css";

async function main() {
  /* ── Year stamp ─────────────────────────────────── */
  const yearEl = document.getElementById("year");
  if (yearEl) yearEl.textContent = String(new Date().getFullYear());

  /* ── Master canvas + World ──────────────────────── */
  const canvas = document.getElementById("master-canvas") as HTMLCanvasElement;
  if (!canvas) throw new Error("#master-canvas not found in DOM");

  const world = new World({ canvas });

  /* ── Register scenes in scroll order ────────────── */
  const hero = new HeroScene();
  const about = new AboutScene();
  world.register(hero);
  world.register(about);

  // Initialize scenes (may be async for asset loading)
  await Promise.all([hero.init(), about.init()]);

  // Build the camera spline from all registered scenes' keyframes
  world.buildCameraPath();

  /* ── Bind global scroll progress to the camera ──── */
  lenis.on("scroll", () => {
    world.setScrollProgress(scrollState.progress);
    world.setScrollVelocity(scrollState.normalizedVelocity);
    hero.setScrollVelocity(scrollState.normalizedVelocity);
  });

  /* ── Start the master loop ──────────────────────── */
  world.start();

  /* ── DOM-level animations ───────────────────────── */
  initSplitText();
  initReveals();

  /* ── Final ScrollTrigger refresh after fonts load ─ */
  (document.fonts?.ready ?? Promise.resolve()).then(() => {
    setTimeout(() => ScrollTrigger.refresh(), 200);
  });

  /* ── Cleanup on HMR ─────────────────────────────── */
  if (import.meta.hot) {
    import.meta.hot.dispose(() => {
      world.dispose();
    });
  }
}

main().catch((err) => {
  console.error("[bootstrap]", err);
});
